/** An editor meant for comment posting, with the addition of some hints for starting a conversation */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback, useContext } from 'react';
import CommentBox from '../CommentBox';
import EditorView from './views/EditorView';
import { CommentSuggestionsContext, CommentSuggestionsContextProvider } from './CommentSuggestionsContext';
// Separate content component to make use of CommentSuggestionsContext
const Content = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { type, nc, onClose, onPost, footerClassName, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy } = _param, rest = _object_without_properties(_param, [
        "type",
        "nc",
        "onClose",
        "onPost",
        "footerClassName",
        'aria-label',
        'aria-labelledby'
    ]);
    const { suggestion } = useContext(CommentSuggestionsContext);
    const submitValidator = useCallback((newState)=>{
        const castedState = newState;
        const editorText = castedState.state.doc.textContent;
        return !newState.isEmpty && (!suggestion || editorText !== suggestion);
    }, [
        suggestion
    ]);
    return /*#__PURE__*/ React.createElement(CommentBox, _object_spread({
        forceLoadOnMount: !!suggestion,
        submitValidator: submitValidator,
        editorView: /*#__PURE__*/ React.createElement(EditorView, {
            nc: nc,
            onCancel: onClose,
            onPost: onPost,
            footerClassName: footerClassName,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            type: type
        }),
        ref: ref
    }, rest));
});
const CommentBoxWithSuggestions = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    return /*#__PURE__*/ React.createElement(CommentSuggestionsContextProvider, null, /*#__PURE__*/ React.createElement(Content, _object_spread({
        ref: ref
    }, props)));
});
CommentBoxWithSuggestions.displayName = 'CommentBoxWithSuggestions';
export default CommentBoxWithSuggestions;

//# sourceMappingURL=CommentBoxWithSuggestions.js.map